import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import ToggleSwitch from '../../../../../../../components/toggle-switch/ToggleSwitch';
import i18n from 'i18';

export const NotificationTimingField = ({ data, field, onChange, ...props }) => {
    const { id, label, needDivider } = field;
    
    // Options for the switch
    const options = [
        { value: 'sendNow', label: i18n.t('enums.sendNow') },
        { value: 'sendLater', label: i18n.t('enums.sendLater') }
    ];

    return (
        <div>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 2,
                    gap: 2
                }}
            >
                <Typography variant="h5">
                    {i18n.t(`columns.${label}`)}
                </Typography>
                <ToggleSwitch
                    options={options}
                    value={data || 'sendNow'}
                    onChange={(value) => onChange(id, value)}
                />
            </Box>
            {needDivider && <Divider sx={{ mb: 2 }} />}
        </div>
    );
};
